<form [formGroup]="officeHoursForm">
  <div class="flex flex-col gap-2 pt-2">
    <span class="font-semibold">Office Hours</span>

    <div class="portal-hours-grid" *ngIf="!editing">
      <div class="flex flex-col">
        <span class="font-semibold">Sun</span>
        <span>{{ officeHours.sunday }}</span>
      </div>
      <div class="flex flex-col">
        <span class="font-semibold">Mon</span>
        <span>{{ officeHours.monday }}</span>
      </div>
      <div class="flex flex-col">
        <span class="font-semibold">Tues</span>
        <span>{{ officeHours.tuesday }}</span>
      </div>
      <div class="flex flex-col">
        <span class="font-semibold">Wed</span>
        <span>{{ officeHours.wednesday }}</span>
      </div>
      <div class="flex flex-col">
        <span class="font-semibold">Thurs</span>
        <span>{{ officeHours.thursday }}</span>
      </div>
      <div class="flex flex-col">
        <span class="font-semibold">Fri</span>
        <span>{{ officeHours.friday }}</span>
      </div>
      <div class="flex flex-col">
        <span class="font-semibold">Sat</span>
        <span>{{ officeHours.saturday }}</span>
      </div>
    </div>

    <div class="portal-hours-grid portal-hours-editor" *ngIf="editing">
      <mat-form-field class="md:w-1/7">
        <mat-label>Sun</mat-label>
        <input matInput formControlName="sunday">
        <mat-error *ngIf="officeHoursForm.get('sunday')?.invalid">
          If closed enter N/A
        </mat-error>
      </mat-form-field>
      <mat-form-field class="md:w-1/7">
        <mat-label>Mon</mat-label>
        <input matInput formControlName="monday">
        <mat-error *ngIf="officeHoursForm.get('monday')?.invalid">
          If closed enter N/A
        </mat-error>
      </mat-form-field>
      <mat-form-field class="md:w-1/7">
        <mat-label>Tues</mat-label>
        <input matInput formControlName="tuesday">
        <mat-error *ngIf="officeHoursForm.get('tuesday')?.invalid">
          If closed enter N/A
        </mat-error>
      </mat-form-field>
      <mat-form-field class="md:w-1/7">
        <mat-label>Wed</mat-label>
        <input matInput formControlName="wednesday">
        <mat-error *ngIf="officeHoursForm.get('wednesday')?.invalid">
          If closed enter N/A
        </mat-error>
      </mat-form-field>
      <mat-form-field class="md:w-1/7">
        <mat-label>Thurs</mat-label>
        <input matInput formControlName="thursday">
        <mat-error *ngIf="officeHoursForm.get('thursday')?.invalid">
          If closed enter N/A
        </mat-error>
      </mat-form-field>
      <mat-form-field class="md:w-1/7">
        <mat-label>Fri</mat-label>
        <input matInput formControlName="friday">
        <mat-error *ngIf="officeHoursForm.get('friday')?.invalid">
          If closed enter N/A
        </mat-error>
      </mat-form-field>
      <mat-form-field class="md:w-1/7">
        <mat-label>Sat</mat-label>
        <input matInput formControlName="saturday">
        <mat-error *ngIf="officeHoursForm.get('saturday')?.invalid">
          If closed enter N/A
        </mat-error>
      </mat-form-field>
    </div>
  </div>
</form>
